import React, { Component } from 'react';
import { connect } from 'react-redux'
import { noAvailableSVG, infinito } from '../../Images/NoAvailableSVG';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js'
import { messagePassToReady } from '../../js/helpers/helperMessages';
import { CUSTOM_COMPONENTS } from '../../js/customElements/customComponents';
import PasswordTextArea from '../workSpace/Others/PasswordTextArea'
import { messageChangeState } from '../../redux/actions/A_messages_to_SM';
import { Singleton } from '../../js/Singleton';
import { SingletonSharedData } from '../../js/singletonSharedData';
import { setNoAvailableList, setNoAvailableRecord, getNoAvailableList, getNoAvailableRecord } from '../../js/Singletons/NoAvailableRecordSingleton.js';
import { consultingApp, noConsultingApp } from '../../redux/actions/A_reducer_consulting';
import StopWatch from "../Header/StopWatch/StopWatch";
import StopWatchCountDown from "../Header/StopWatch/StopWatchCountDown";
import { INTEGRATION } from '../../constants';
import SingletonWebSocket from '../../js/Singletons/SingletonWebSocket';
let _this = null;
class noAvailableLocked extends Component {
  constructor(props) {
    super(props);
    _this = this;
    this.state = {
      frame: 0,
      timeNoAvailable: "",
      requireadminPass: true,
      incremental: false,
      extraTime: false,
      agentPassword: "",
      adminPassword: "",
      agentPassError: false,
      adminPassError: false,
	    timeIsEnd: false,
      noAvailableRecord: [],
      noAvailableList: [],
      description: '' 
    };
    this.isRenderCount = false;
    this.secs = 0;
    let APIFact = new APIFactory();
    this.apiCont = APIFact.buildClient();
    this.language = new Singleton();
    this.sharedData = new SingletonSharedData();
    this.integrationData=null;
  }
  componentDidMount() {
    var _this = this;
    if (!getNoAvailableList()) {
      let objectResponse = this.apiCont.getObjectResponse();
      this.apiCont.getListNoAvailable(this.sharedData.getParameters().UserID, objectResponse);
      objectResponse.onError = function (messageError) {
        console.warn("Error", messageError);
      };
      objectResponse.onSuccess = function (objResponse) {
        setNoAvailableList(objResponse.Response);
        _this.setState({ noAvailableList: getNoAvailableList() });
      };
    }
    if (!getNoAvailableRecord()) {
      let objectResponse = this.apiCont.getObjectResponse();
      this.apiCont.getNotReadyHistory(this.sharedData.getParameters().UserID, objectResponse);
      objectResponse.onError = function (messageError) {
        console.warn("Error", messageError);
      };
      objectResponse.onSuccess = function (objResponse) {
        setNoAvailableRecord(objResponse.Response);
        _this.setState({ noAvailableRecord: getNoAvailableRecord() });
      };
    }
    this.agentPass = this.refs["agentPass"];
    this.adminPass = this.refs["adminPass"];
    this.agentPass.focus();
    this.isRenderCount = true;
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (!_this.integrationData && nextProps.messagesIntegrations && nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action==INTEGRATION.READY_WITH_PASSWORD) {
      if (_this.state.requireadminPass) {
        _this.setState({
          adminPassword: nextProps.messagesIntegrations.dataMessageIntegration.supervisorPwd,
          agentPassword: nextProps.messagesIntegrations.dataMessageIntegration.agentPwd,
          agentPassError: false,
          adminPassError: false})
        setTimeout(() => {
          _this.closeLocked()
        }, 1000);
      } else {
        _this.setState({
          agentPassword: nextProps.messagesIntegrations.dataMessageIntegration.agentPwd,
          agentPassError: false,
          adminPassError: false})
        setTimeout(() => {
          _this.enterAgent()
        }, 1000);
      }
      _this.integrationData=nextProps.messagesIntegrations.dataMessageIntegration;
    }
    
    _this.secs = nextProps.noAvailableState.time < 0 ? 0 : nextProps.noAvailableState.time;
    return {
      description: nextProps.noAvailableState.description,
      frame: nextProps.noAvailableState.frame,
      requireadminPass: nextProps.noAvailableState.supervisorPass,
      incremental: state.timeIsEnd ? state.timeIsEnd : nextProps.noAvailableState.time <= 0,
      extraTime: nextProps.noAvailableState.time !== 0
    };   
   
  
  }
  processTimer(time) {
    if (time === "00:00:00") {
      this.setState({ timeIsEnd: true });
    }
  }
  putStateError(agentError, AdminError) {
    this.setState({
      agentPassError: agentError,
      adminPassError: AdminError,
      agentPassword: "",
      adminPassword: "",
    });
    this.props.noConsultingApp();
    this.agentPass.focus();
  }
  noStateError() {
    this.setState({
      agentPassError: false,
      adminPassError: false
    });
  }
  closeLocked() {
    var _this = this;
    let objectResponse = this.apiCont.getObjectResponse();
    let validationData = messagePassToReady(this.state.agentPassword, this.state.adminPassword, this.state.requireadminPass);
    this.apiCont.validateNotAvailablePassword(validationData, objectResponse);
    objectResponse.onError = function (messageError) {
      _this.putStateError(true, true);
      const integrationMessage = { client: "galatea", data: messageError, action: "errorOnAvailableStatus" };
      SingletonWebSocket.send(integrationMessage);
    };
    objectResponse.onSuccess = function (objResponse) {
      if (objResponse.Response.AgentOk && (!_this.state.requireadminPass || (_this.state.requireadminPass && objResponse.Response.SupervisorOk))) {
          _this.props.messageChangeState();
          _this.props.noConsultingApp();
        clearInterval(_this.timerTime);
      } else {
        _this.putStateError(!objResponse.Response.AgentOk, !objResponse.Response.SupervisorOk);
      }
    };
    _this.integrationData=null;
  }

  enterAgent() {
    if (!this.state.requireadminPass) {
      this.props.consultingApp();
      this.closeLocked();
    } else {
      this.adminPass.focus();
    }
  }
  focusAgent() {
    // let _this = this;
    // setTimeout(()=> { _this.agentPass.focus() }, 100);
  }

  getHistory() {
    let ITEM = this.state.noAvailableRecord.filter((noAvailable) => { return noAvailable.Description === this.props.noAvailableState.description });
    let ITEM2 = this.state.noAvailableList.filter((noAvailable) => { return noAvailable.Description === this.props.noAvailableState.description });
    let history = "";
    if (ITEM.length) {
      if (ITEM[0].Total === "n") {
        return infinito;
      }
      else {
        history = (ITEM[0].Count + 1) + "/" + ITEM[0].Total;
      }
    }
    else if (ITEM2.length) {
      if (ITEM2[0].NumberOfEvents === "n") {
        return infinito;
      }
      else {
        history = "1/" + ITEM2[0].NumberOfEvents;
      }
    }
    return <p className="indexNoAvailable">{history}</p>
  }

  renderTimmer() {
    if (!this.isRenderCount) {
      return "00:00:00";
    }
    return this.state.incremental ?
      <StopWatch onChange={() => { }} isAscending /> :
      (<StopWatchCountDown
        key={this.state.description}
        onChange={(timeCounter) => this.processTimer(timeCounter)}
        hours={Math.floor(this.secs / 3600)}
        minutes={Math.floor((this.secs % 3600) / 60)}
        secondsInitial={Math.floor((this.secs % 3600) % 60)}
      />)
  }

  render() {
    return (
      <div className="noAvailableLocked02">
        <div className="noAvailableLockedBlackContainer"></div>
        <div className={"noAvailableLockedContainer " + (this.state.requireadminPass && "adminPass")} style={{ zIndex: this.props.style }} onClick={() => this.props.goTopZ(this.props.id)}>
          {CUSTOM_COMPONENTS["draggableHeader"](noAvailableSVG, this.language.getText('GUIDisableModetitle'), null)}
          <div className="noAvailableIcon">{this.sharedData.getIconNoAvailable(this.state.frame)}</div>
          <div className="noAvailableInfo">
            <div className="container20">
              <div className={`iconNoAvailable ${(this.state.incremental && this.state.extraTime ? "redNoAvailable" : "")}`}>{this.sharedData.getIconNoAvailable(this.state.frame)}</div>
              <p className={`titleNoAvailable ${(this.state.incremental && this.state.extraTime ? "red" : "")}`}>{this.props.noAvailableState.description}</p>
            </div>
            <div className="timerNoAvailableLocked">
              <p className={`regular52 ${(this.state.incremental && this.state.extraTime ? "red" : "")}`}>
                {this.renderTimmer()}
              </p>
            </div>
            <p className="passwordTitle noTopMargin">{this.language.getText('GUIDisableModeagentPassword')}</p>
            <PasswordTextArea ref="agentPass"
              tabindex="1"
              value={this.state.agentPassword}
              onChange={(text) => { this.setState({ agentPassword: text }); this.noStateError() }}
              onEnterKey={() => this.enterAgent()}
              onBlur={() => { this.state.requireadminPass ? this.adminPass.focus() : this.focusAgent() }}
              height={30}
              hasError={this.state.agentPassError}
              width={190} />
            {this.state.agentPassError && <p className="errorPassword"><span className="margin-right">&#9679;</span>  {this.language.getText('GUIPasswordChangeincorrectPassword')}</p>}
            {this.state.requireadminPass && <div className="noMarginPadding">
              <p className={"passwordTitle " + (this.state.agentPassError && "noTopMargin")}>{this.language.getText('GUIDisableModesupervisorPassword')}</p>
              <PasswordTextArea ref="adminPass"
                tabindex="2"
                value={this.state.adminPassword}
                onChange={(text) => { this.setState({ adminPassword: text }); this.noStateError() }}
                onEnterKey={() => this.closeLocked()}
                height={30}
                hasError={this.state.adminPassError}
                onBlur={() => this.focusAgent()}
                width={190} />
              {this.state.adminPassError && <p className="errorPassword"><span className="margin-right">&#9679;</span>  {this.language.getText('GUIPasswordChangeincorrectPassword')}</p>}
            </div>}
            <div className="NoAvailableLockedHistory">
              {this.getHistory()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    noAvailableState: state.noAvailableState,
    messagesIntegrations: state.messagesIntegrations
  }
}
function mapDispatchToProps(dispatch) {
  return ({
    messageChangeState: () => { dispatch(messageChangeState()); },    
    consultingApp: () => { dispatch(consultingApp()); },
    noConsultingApp: () => { dispatch(noConsultingApp()); },
  });
}
export default noAvailableLocked = connect(
  mapStateToProps,
  mapDispatchToProps
)(noAvailableLocked);



// WEBPACK FOOTER //
// ./src/components/workSpace/noAvailableLocked.jsx